import React from "react";
import { Tooltip } from "@mui/material";
import { formatPrice, formatPriceAmount } from "../utils/saleUtils";
import "./PurchaseCouponMark.css";

export const getPurchaseCoupon = (coupon) => {
  if (!coupon || typeof coupon !== "object") return null;
  const code = String(coupon.code || "").trim();
  if (!code) return null;

  const percentage = Number(coupon.discount_percentage);
  const amount = Number(coupon.discount_amount);

  return {
    code,
    percentage: Number.isFinite(percentage) && percentage > 0 ? percentage : null,
    amount: Number.isFinite(amount) && amount > 0 ? amount : null,
  };
};

export const PurchaseCouponMark = ({ coupon }) => {
  const parsed = getPurchaseCoupon(coupon);
  if (!parsed) return null;

  const tooltip = [
    parsed.code,
    parsed.percentage != null ? `${parsed.percentage}% off` : null,
    parsed.amount != null ? `saved ${formatPriceAmount(parsed.amount)}` : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <Tooltip
      title={tooltip}
      arrow
      enterDelay={0}
      enterNextDelay={0}
      leaveDelay={80}
      placement="top"
      slotProps={{
        popper: { sx: { zIndex: 2000 } },
        tooltip: {
          sx: {
            bgcolor: "#171717",
            color: "#fff",
            fontSize: 12,
            fontWeight: 600,
            px: 1.25,
            py: 0.85,
            borderRadius: "8px",
            boxShadow: "0 8px 20px rgba(17, 17, 17, 0.2)",
          },
        },
        arrow: { sx: { color: "#171717" } },
      }}
    >
      <span className="purchase-coupon-mark">
        <span className="purchase-coupon-mark__icon" aria-hidden="true">
          %
        </span>
        {parsed.code}
      </span>
    </Tooltip>
  );
};

export const PurchasePriceCell = ({ price, coupon, isRefunded = false }) => (
  <div className="purchase-price-cell">
    {isRefunded ? (
      <span
        className="badge rounded-pill"
        style={{ backgroundColor: "#dc3545", fontSize: "10px" }}
      >
        Refunded
      </span>
    ) : null}
    <span className="purchase-price-cell__amount">{formatPrice(price)}</span>
    <PurchaseCouponMark coupon={coupon} />
  </div>
);

export default PurchaseCouponMark;
